import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast } from 'react-toastify';
import { CircularProgress, Card, CardContent, Typography, Divider, Box, Grid, Button, MenuItem, Select, TextField } from '@mui/material';
import useCustomerProfile from '../customerProfile/useCustomerProfile';
import PersonIcon from '@mui/icons-material/Person';
import { formatAmount } from '../../utils/formatAmount';
import { formatDate } from '../../utils/dateUtils';

const Crm = () => { 

  const [rowData, setRowData] = useState([]);
  const [customerData, setCustomerData] = useState('')
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(null);
  const [latestOrderDate, setLatestOrderDate] = useState(null);
  const [followPeriod, setFollowPeriod] = useState(30);
  const [complain, setComplain] = useState(null);
  const [followRecords, setFollowRecords] = useState([]);
  const [note, setNote] = useState('');
  const [allProfile, setAllProfile] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // State for search input

  const [columnDefs, setColumnDefs] = useState([
    { headerName: 'Contact', field: 'contact', flex: 2 },
    { headerName: 'Phone', field: 'phone', flex: 1 },
    { headerName: 'Channel', field: 'channel', flex: 1 },
  ]);

  const { profiles, isLoading, getFollowProfile, getCustomerDetails, followCrm } = useCustomerProfile()

  const handleOpenProfile = () => {
		if (customerData && customerData.smileName) {
			const url = `/customer-profile?smileName=${encodeURIComponent(customerData.smileName)}`;
			window.open(url, '_blank');
		} else {
			toast.error('ใส่ชื่อลูกค้าก่อน');
		}
	}

  const handleFollowCrm = async () => {
    if(complain === null || complain === ""){
      toast.error("กรุณาเลือกก่อนว่า ลูกค้าบ่นหรือไม่บ่น");
      return;
    }
    const response = await followCrm({
      customerId: customerData.customerId,
      crmId: customerData.id, 
      followPeriod,
      note,
      complain,
      totalAmount});
    if(response){
      toast.success('Follow CRM period set successfully');
      setCustomerData('')
      setNote('')
      setFollowPeriod(30)
      setComplain(true)
    }else{
      toast.error("Something wrong")
    }
  };

  const toggleAllProfile = () => {
    setAllProfile((prev) => !prev);
  };

  const fetchProfiles = async () => {
    await getFollowProfile({allProfile}); // Pass the allProfile flag to fetch data conditionally
  };

  useEffect(() => {
    fetchProfiles();
  }, [allProfile]);


  const gridOptions = {
    onRowClicked: (event) => {
      setCustomerData(event.data); // Set clicked row data
    },
    getRowStyle: (params) => {
      if (params.data.isFirstAppearance) {
        return { backgroundColor: '#DFF2BF' }; // Light green for first appearance
      } 
    }
  };

  useEffect(() => {
    getFollowProfile({allProfile})
  }, [])

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    if (query) {
      const filteredData = rowData.filter((item) =>
        ['contact', 'phone', 'channel', 'smileName']
          .some((field) => item[field]?.toLowerCase().includes(query))
      );
      setFilteredRowData(filteredData);
    } else {
      setFilteredRowData(rowData);
    }
  };
  
  useEffect(() => {
    if (profiles) {
      const formattedData = profiles.map((item) => ({
        ...item,
        contact: item.contact || item['CustomerProfile.contact'], // Handle raw data fields
        phone: item.phone || item['CustomerProfile.phone'],
        channel: item.channel || item['CustomerProfile.channel'],
        smileName: item.smileName || item['CustomerProfile.smileName'],
        productRate: item.productRate || item['CustomerProfile.productRate'],
        isFirstAppearance: item.isFirstAppearance, // Keep flag for styling or conditional rendering
      }));

      setRowData(formattedData);
      setFilteredRowData(formattedData); // Set filtered data initially to all rows
    }
  }, [profiles]);
  

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      if (customerData && customerData.customerId) {
        const details = await getCustomerDetails(customerData.customerId);
        if (details) {
          setTotalAmount(details.totalAmount);
          setFollowRecords(details.followRecords);
          setLatestOrderDate(details.latestOrderDate)
        }
      }
    };

    fetchCustomerDetails();
  }, [customerData]);

  return (
    <div className="ag-theme-alpine mx-auto" style={{ width: '100%' }}>
      <h2>Follow ลูกค้า</h2>
      <div className='flex justify-between'>
        <div className='flex space-x-3'>
          <Button
            variant="contained"
            color={allProfile ? 'secondary' : 'primary'}
            onClick={toggleAllProfile}
          >
            {allProfile ? 'Show Filtered Data' : 'Show All Data'}
          </Button>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
          />
          <div className="flex justify-center">
            {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          </div>
        </div>
      </div>
      <div className='grid grid-cols-5 gap-x-3'>
        <div className='col-span-2'>
          <div className='flex mt-3'>
          </div>
          <div style={{ height: '80vh'}}>
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={filteredRowData}
              defaultColDef={{ resizable: true }}
            />
          </div>
        </div>
        <div className='col-span-3 mt-3'>
      {customerData ? (
        <Card className='p-4 shadow-lg rounded-lg border'>
          <CardContent>
            <div className='flex justify-between'>  
              <Typography variant="h5" gutterBottom>
                <PersonIcon fontSize="large" style={{ verticalAlign: 'bottom', color: '#3f51b5' }} />
                {' '}Customer Details
              </Typography>
              <button 
              type="button"
              className="bg-red-500 text-white rounded-md hover:bg-red-600 btn-sm text-sm p-1 px-2"
              onClick={handleOpenProfile}
              >
                Profile
              </button>
              
            </div>

            <Divider style={{ margin: '10px 0' }} />

            {/* Grid Container for 2x2 Layout */}
            <Grid container spacing={2}>
              {/* Contact */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Contact:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{customerData.contact}</Typography>
                </Box>
              </Grid>

              {/* Phone */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Phone:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{customerData.phone}</Typography>
                </Box>
              </Grid>

              <Divider style={{ margin: '10px 0' }} />

              {/* Rate */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Rate:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{customerData.productRate}</Typography>
                </Box>
              </Grid>

              {/* Channel */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Channel:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{customerData.channel}</Typography>
                </Box>
              </Grid>

              {/* Total Amount */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Total Amount:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{totalAmount !== null ? `${formatAmount(totalAmount)} ¥` : "N/A"}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Last Order:</Typography>
                  <Typography variant="body1" style={{ marginLeft: 8 }}>{formatDate(latestOrderDate)}</Typography>
                </Box>
              </Grid>
            </Grid>
            <Divider style={{ margin: '20px 0' }} />
            {/* Past CRM Records */}
            <Typography variant="h6" gutterBottom>Past CRM Records</Typography>
            <div style={{ height: '200px', width: '100%' }} className="ag-theme-alpine">
              <AgGridReact
                columnDefs={[
                  { headerName: 'Follow Date', field: 'followDate', flex: 1, valueFormatter:({value}) => formatDate(value)},
                  { headerName: 'Total Amount', field: 'totalAmount', flex: 1, valueFormatter: ({ value }) => `${formatAmount(value)} ¥` },
                  { headerName: 'Note', field: 'note', flex: 2 },
                ]}
                rowData={followRecords}
                defaultColDef={{ resizable: true }}
              />
            </div>

            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6" gutterBottom>CRM Result</Typography>
            <div className='flex space-x-5'>
              <Box mb={2}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Follow Period</Typography>
                <Select
                  value={followPeriod}
                  onChange={(e) => setFollowPeriod(e.target.value)}
                  variant="outlined"
                >
                  <MenuItem value={7}>7 days</MenuItem>
                  <MenuItem value={15}>15 days</MenuItem>
                  <MenuItem value={30}>30 days</MenuItem>
                </Select>
              </Box>
              <Box mb={2}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Complain</Typography>
                <Select
                  value={complain !== null ? complain : ""}
                  onChange={(e) => setComplain(e.target.value)}
                  variant="outlined"
                  style={{ width: '100px' }}
                >
                  <MenuItem value="" disabled>
                    กรุณาเลือก
                  </MenuItem>
                  <MenuItem value={true}>บ่น</MenuItem>
                  <MenuItem value={false}>ไม่บ่น</MenuItem>
                </Select>
              </Box>
            </div>  
            <Box mb={2}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Note</Typography>
              <TextField
                value={note}
                onChange={(e) => setNote(e.target.value)}
                multiline
                fullWidth
                variant="outlined"
                rows={4}
              />
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleFollowCrm}
              style={{ marginLeft: 0 }}
            >
              Done
            </Button>
          </CardContent>
        </Card>
      ) : (
        <></>
      )}
    </div>
      </div>
    </div>
  );
}

export default Crm;